<template>
  <div>
    <div class="big-error-w">
      <h1>
        {{ type }}
      </h1>
      <h5>
        {{ title }}
      </h5>
      <h4>
        {{ description }}
      </h4>
    </div>
    <div class="back">
      <a href="#"
         @click="$router.go(-1)">
        <h5>Back</h5>
      </a>
    </div>
  </div>
</template>
<script>
export default {
	  name: 'auth-error',
	  props: {
		'type': {
			type: String,
			default: '404'
		},
		'title': {
			type: String,
			default: '...'
		},
		'description': {
			type: String,
			default: '...'
		}
	}
}
</script>
<style>
  .back {
    padding: 0 0 10px 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/errors/index.vue